import React from 'react';
import { Modal } from '../ui/Modal';
import { Avatar } from '../ui/Avatar';
import { SkillBar } from '../ui/SkillBar';
import { Stars } from '../ui/Stars';
import { User } from '../../types';
import { sanitize } from '../../lib/security';
import { useStore } from '../../store';
import { t } from '../../lib/i18n';

interface MercenaryProfileModalProps {
  user: User | null;
  open: boolean;
  onClose: () => void;
  onMessage: (userId: string) => void;
  onReport: (userId: string, name: string) => void;
}

export const MercenaryProfileModal: React.FC<MercenaryProfileModalProps> = ({
  user, open, onClose, onMessage, onReport,
}) => {
  const { currentUser, lang } = useStore();
  if (!user) return null;
  const isSelf = currentUser?.id === user.id;

  return (
    <Modal open={open} onClose={onClose} title={`${user.firstName} ${user.lastName}`} maxWidth="520px">
      <div className="merc-profile-modal">
        <div className="merc-profile-header">
          <Avatar user={user} size={90} />
          <div>
            <h2 className="merc-name">{sanitize(user.firstName)} {sanitize(user.lastName)}</h2>
            <p className="merc-location">📍 {sanitize(user.city)}, {sanitize(user.country)}</p>
            <Stars rating={user.rating} count={user.ratingCount} />
          </div>
        </div>

        {user.bio && (
          <>
            <hr className="divider" />
            <p className="merc-bio-full">"{sanitize(user.bio)}"</p>
          </>
        )}

        {user.skills.length > 0 && (
          <>
            <hr className="divider" />
            <h4 className="skills-section-title">Skills</h4>
            <div className="skills-list">
              {user.skills.map((s) => <SkillBar key={s.name} skill={s} />)}
            </div>
          </>
        )}

        {currentUser && !isSelf && (
          <div className="merc-profile-actions">
            <button className="btn btn-gold" onClick={() => { onMessage(user.id); onClose(); }}>
              💬 {t(lang, 'mercs_message')}
            </button>
            <button className="report-btn" onClick={() => onReport(user.id, `${user.firstName} ${user.lastName}`)}>
              ⚠ {t(lang, 'report_btn')}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};
